import { render, staticRenderFns } from "./chartBiasMail.vue?vue&type=template&id=720f5b50&scoped=true&"
import script from "./chartBiasMail.vue?vue&type=script&lang=js&"
export * from "./chartBiasMail.vue?vue&type=script&lang=js&"
import style0 from "./chartBiasMail.vue?vue&type=style&index=0&id=720f5b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f5b50",
  null
  
)

export default component.exports